"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _Menu = _interopRequireDefault(require("@mui/icons-material/Menu"));

var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));

var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
 * Copyright © 2021 Lexcelon LLC <info@lexcelon.com>
 * Licensed for non-distributable use
 */
// Icons

/* --- Custom App Bar --- */
function Header(_ref) {
  let {
    location,
    logo,
    logoDescription,
    links,
    backgroundColor,
    textColor,
    accentColor = null,
    drawer = false,
    onLogout = null,
    isLoading = false,
    onOpen = () => {}
  } = _ref;
  const [linkMenuanchorEl, setLinkMenuAnchorEl] = (0, _react.useState)(null);
  const [selectedLink, setSelectedLink] = (0, _react.useState)(null);
  const [isSidePanelOpen, setSidePanelOpen] = (0, _react.useState)(false);

  const handleLinkMenuClick = (event, link) => {
    setLinkMenuAnchorEl(event.currentTarget);
    setSelectedLink(link);
  };

  const handleLinkMenuClose = () => {
    setLinkMenuAnchorEl(null);
    setSelectedLink(null);
  };

  const toggleSideMenu = () => {
    if (!isSidePanelOpen) onOpen();
    setSidePanelOpen(!isSidePanelOpen);
  };

  const closeSideMenu = () => {
    setSidePanelOpen(false);
  };

  const logoutUser = () => {
    closeSideMenu();
    onLogout();
  };

  return /*#__PURE__*/_react.default.createElement(_material.AppBar, {
    style: {
      backgroundColor: backgroundColor
    },
    position: "static"
  }, /*#__PURE__*/_react.default.createElement(_material.Toolbar, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/"
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: 150,
    height: 50,
    src: logo,
    alt: logoDescription,
    title: logoDescription,
    style: {
      objectFit: 'contain',
      cursor: 'pointer'
    }
  }))), isLoading ? /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    size: 20,
    style: {
      color: 'white'
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Hidden, {
    mdUp: true,
    implementation: "css"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1,
      textAlign: 'right'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-controls": "nav-menu",
    "aria-haspopup": "true",
    onClick: toggleSideMenu
  }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
    style: {
      color: textColor
    }
  })))), /*#__PURE__*/_react.default.createElement(_material.Drawer, {
    anchor: 'right',
    open: isSidePanelOpen,
    onClose: toggleSideMenu
  }, /*#__PURE__*/_react.default.createElement(SideMenu, {
    location: location,
    toggle: toggleSideMenu,
    links: links,
    logo: logo,
    logoDescription: logoDescription,
    backgroundColor: backgroundColor,
    textColor: textColor,
    accentColor: accentColor,
    logoutUser: onLogout == null ? null : logoutUser
  })), /*#__PURE__*/_react.default.createElement(_material.Hidden, {
    mdDown: true,
    implementation: "css"
  }, drawer ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1,
      textAlign: 'right'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-controls": "nav-menu",
    "aria-haspopup": "true",
    onClick: toggleSideMenu
  }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
    style: {
      color: textColor
    }
  }))) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 3,
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, links.map((link, index) => {
    var _selectedLink$subLink;

    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      variant: "text",
      style: {
        marginLeft: '10px',
        textAlign: 'center',
        fontSize: '14px',
        color: !accentColor || isSelected(location.pathname, link.slug) ? textColor : accentColor,
        textDecoration: !accentColor && isSelected(location.pathname, link.slug) ? 'underline' : null,
        textUnderlineOffset: '3px'
      },
      href: link.subLinks ? null : link.slug,
      "aria-haspopup": link.subLinks ? 'true' : 'false',
      onClick: link.subLinks ? e => handleLinkMenuClick(e, link) : null
    }, link.text, link.subLinks && (linkMenuanchorEl && (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.slug) === link.slug ? /*#__PURE__*/_react.default.createElement(_ExpandLess.default, null) : /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null))), (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.subLinks) && /*#__PURE__*/_react.default.createElement(_material.Menu, {
      id: "simple-menu",
      anchorEl: linkMenuanchorEl,
      keepMounted: true,
      open: Boolean(linkMenuanchorEl),
      onClose: handleLinkMenuClose,
      elevation: 0,
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, selectedLink === null || selectedLink === void 0 ? void 0 : (_selectedLink$subLink = selectedLink.subLinks) === null || _selectedLink$subLink === void 0 ? void 0 : _selectedLink$subLink.map((subLink, subLinkIndex) => /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: subLinkIndex,
      component: "button",
      onClick: handleLinkMenuClose,
      href: (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.slug) + subLink.slug,
      style: {
        fontSize: '14px'
      }
    }, subLink.text))));
  }), onLogout != null && /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "text",
    style: {
      marginLeft: '10px',
      textAlign: 'center',
      fontSize: '14px',
      color: textColor
    },
    onClick: logoutUser
  }, "Logout"))))));
}

Header.propTypes = {
  location: _propTypes.default.object.isRequired,
  logo: _propTypes.default.string.isRequired,
  logoDescription: _propTypes.default.string.isRequired,
  links: _propTypes.default.array.isRequired,
  backgroundColor: _propTypes.default.string.isRequired,
  textColor: _propTypes.default.string.isRequired,
  accentColor: _propTypes.default.string,
  drawer: _propTypes.default.bool,
  onLogout: _propTypes.default.func,
  isLoading: _propTypes.default.bool,
  onOpen: _propTypes.default.func
};
/* --- Side Menu --- */

function SideMenu(_ref2) {
  let {
    toggle,
    location,
    links,
    logo,
    logoDescription,
    backgroundColor,
    textColor,
    accentColor = null,
    logoutUser = null
  } = _ref2;
  const [linkMenuanchorEl, setLinkMenuAnchorEl] = (0, _react.useState)(null);
  const [selectedLink, setSelectedLink] = (0, _react.useState)(null);

  const handleLinkMenuClick = (event, link) => {
    setLinkMenuAnchorEl(event.currentTarget);
    setSelectedLink(link);
  };

  const handleLinkMenuClose = () => {
    setLinkMenuAnchorEl(null);
    setSelectedLink(null);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    onKeyDown: toggle,
    style: {
      width: '250px',
      height: '100%',
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_material.List, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: 150,
    height: 150,
    style: {
      objectFit: 'contain'
    },
    src: logo,
    alt: logoDescription,
    title: logoDescription
  })), /*#__PURE__*/_react.default.createElement(_material.Divider, null), links.map((link, index) => link == null ? /*#__PURE__*/_react.default.createElement(_material.Divider, {
    key: index
  }) : /*#__PURE__*/_react.default.createElement("div", {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_material.ListItem, {
    button: true,
    component: "button",
    href: link.subLinks ? null : link.slug,
    "aria-haspopup": link.subLinks ? 'true' : 'false',
    onClick: link.subLinks ? e => handleLinkMenuClick(e, link) : toggle,
    style: {
      marginRight: '40px',
      color: !accentColor || isSelected(location.pathname, link.slug) ? textColor : accentColor,
      textDecoration: !accentColor && isSelected(location.pathname, link.slug) ? 'underline' : null,
      textUnderlineOffset: '3px'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
    primary: link.text
  }), link.subLinks && (linkMenuanchorEl && (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.slug) === link.slug ? /*#__PURE__*/_react.default.createElement(_ExpandLess.default, null) : /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null))), (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.subLinks) && /*#__PURE__*/_react.default.createElement(_material.Menu, {
    id: "simple-menu",
    anchorEl: linkMenuanchorEl,
    keepMounted: true,
    open: Boolean(linkMenuanchorEl),
    onClose: handleLinkMenuClose,
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.subLinks.map((subLink, subLinkIndex) => /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    key: subLinkIndex,
    component: "button",
    onClick: handleLinkMenuClose,
    href: (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.slug) + subLink.slug,
    style: {
      fontSize: '14px'
    }
  }, subLink.text)), logoutUser != null && /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    component: "button",
    onClick: logoutUser,
    style: {
      fontSize: '14px'
    }
  }, "Logout")))), logoutUser != null && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Divider, null), /*#__PURE__*/_react.default.createElement(_material.ListItem, {
    button: true,
    component: "button",
    onClick: logoutUser,
    style: {
      marginRight: '40px',
      color: textColor
    }
  }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
    primary: "Logout"
  }))), /*#__PURE__*/_react.default.createElement(_material.Divider, null)));
}

SideMenu.propTypes = {
  location: _propTypes.default.object.isRequired,
  toggle: _propTypes.default.func.isRequired,
  links: _propTypes.default.array.isRequired,
  logo: _propTypes.default.string.isRequired,
  logoDescription: _propTypes.default.string.isRequired,
  backgroundColor: _propTypes.default.string.isRequired,
  textColor: _propTypes.default.string.isRequired,
  accentColor: _propTypes.default.string,
  logoutUser: _propTypes.default.func
};
/* --- Header Wrapper --- */

class HeaderWrapper extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(Header, this.props);
  }

}

HeaderWrapper.propTypes = {
  location: _propTypes.default.object.isRequired,
  logo: _propTypes.default.string.isRequired,
  logoDescription: _propTypes.default.string.isRequired,
  links: _propTypes.default.array.isRequired,
  backgroundColor: _propTypes.default.string.isRequired,
  textColor: _propTypes.default.string.isRequired,
  accentColor: _propTypes.default.string,
  drawer: _propTypes.default.bool,
  onLogout: _propTypes.default.func
};

var _default = (0, _reactRouterDom.withRouter)(HeaderWrapper);

exports.default = _default;

function isSelected(currentPathname, slug) {
  return currentPathname === '/' && slug === '/' ? true : currentPathname.toLowerCase() === slug.toLowerCase() && slug !== '/';
}